import { TreeSelect } from 'antd'
import { WrappedFieldProps } from 'redux-form';
import { TreeSelectProps } from 'antd/lib/tree-select';
import * as React from 'react';
import FormItem from 'antd/lib/form/FormItem';

interface TreeSelectFieldProps extends WrappedFieldProps {
    readonly treeSelectProps: TreeSelectProps;
}

export default function renderTreeSelect(props: TreeSelectFieldProps) {
    
    const { input, treeSelectProps, ...rest } = props;
    return (
        <FormItem
            {...rest}
        >
            <TreeSelect
                value={input.value ? input.value : undefined}
                onChange={input.onChange}
                {...treeSelectProps}
                // {...rest}
            />
        </FormItem>
    );
}



// WEBPACK FOOTER //
// ./src/reduxFormAntd/TreeSelectField.tsx